/* Tab Start */
document.addEventListener("DOMContentLoaded", () => {

    document.querySelectorAll(".Tabs_common_main_new").forEach(container => {

        const tabs = container.querySelectorAll(".Tabs_common_inner_new");
        const contents = container.querySelectorAll(".tabcontent");

        const group = container.querySelector("[data-tab-group]");
        const bg = group ? group.querySelector(".tab_background_new") : null;

        function moveBgToTab(tab) {
            if (!group || !bg) return;

            const tabsArr = Array.from(tabs);
            const isLast = tab === tabsArr[tabsArr.length - 1];

            const tabRect = tab.getBoundingClientRect();
            const groupRect = group.getBoundingClientRect();

            let offset = tabRect.left - groupRect.left;

            // 3px gap on last tab
            if (isLast) offset -= 3;

            bg.style.width = `${tabRect.width}px`;
            bg.style.transform = `translateX(${offset}px)`;
        }

        function activateTab(tab) {
            const tabId = tab.getAttribute("tab_id");
            if (!tabId) return;

            tabs.forEach(t => t.classList.remove("active"));
            contents.forEach(c => c.style.display = "none");

            tab.classList.add("active");

            const target = container.querySelector(`.${tabId}_open`);
            if (target) target.style.display = "block";

            moveBgToTab(tab);
        }

        // 🔥 Recalculate background position on screen resize
        window.addEventListener("resize", () => {
            const activeTab = container.querySelector(".Tabs_common_inner_new.active");
            if (activeTab) moveBgToTab(activeTab);
        });

        tabs.forEach(tab => {
            tab.addEventListener("click", () => activateTab(tab));
        });

        const firstActive = container.querySelector(".Tabs_common_inner_new.active") || tabs[0];
        if (firstActive) activateTab(firstActive);

        const navMenu = document.querySelector(".menu-list__list-item");

        navMenu.addEventListener("mouseenter", () => {
            const firstActive = container.querySelector(".Tabs_common_inner_new.active") || tabs[0];
            if (firstActive) activateTab(firstActive);
        });

    });

});
/* Tab End */

/* Accordian Start */
document.querySelectorAll(".accordion").forEach(acc => {
    const items = acc.querySelectorAll("li");

    items.forEach(item => {
        const question = item.querySelector(".question");
        const answer = item.querySelector(".answer");

        if (!question || !answer) return;

        // Ensure correct default state
        if (item.classList.contains("open")) {
            answer.style.display = "block";
            answer.style.height = "auto";
        } else {
            answer.style.display = "none";
            answer.style.height = 0;
        }

        question.addEventListener("click", () => {
            const isOpen = item.classList.contains("open");

            // Close all other items
            items.forEach(i => {
                if (i === item) return;
                i.classList.remove("open");
                const a = i.querySelector(".answer");
                if (a) {
                    a.style.height = a.scrollHeight + "px"; // ensure correct closing start
                    requestAnimationFrame(() => {
                        a.style.transition = "height 300ms ease";
                        a.style.height = "0px";
                    });
                    setTimeout(() => {
                        a.style.display = "none";
                        a.style.removeProperty("transition");
                    }, 300);
                }
            });

            // If the clicked one was open, just close it
            if (isOpen) {
                item.classList.remove("open");
                answer.style.height = answer.scrollHeight + "px";
                requestAnimationFrame(() => {
                    answer.style.transition = "height 300ms ease";
                    answer.style.height = "0px";
                });
                setTimeout(() => {
                    answer.style.display = "none";
                    answer.style.removeProperty("transition");
                }, 300);
                return;
            }

            // Otherwise, open it
            item.classList.add("open");
            answer.style.display = "block";
            answer.style.height = "auto";              // get natural height
            const endHeight = answer.scrollHeight + "px";
            answer.style.height = "0px";               // restart animation
            requestAnimationFrame(() => {
                answer.style.transition = "height 300ms ease";
                answer.style.height = endHeight;
            });
            // Wait until animation finishes, then scroll
            setTimeout(() => {
                answer.style.height = "auto";
                answer.style.removeProperty("transition");

                // ✅ Scroll ONLY if inside Product_meta_collapsible_main_new
                const container = item.closest(".Product_meta_collapsible_main_new");
                if (container) {
                  // Scroll to question AFTER opening
                  const offset = 100; // adjust to your header height
                  const y = question.getBoundingClientRect().top + window.pageYOffset - offset;

                  window.scrollTo({
                      top: y,
                      behavior: "smooth"
                  });
                }
            }, 300)
        });
    });
});
/* Accordian End */

/* Mobile Header Start */
function mobileMenuHeight() {
  // Get announcement bar height (with margin)
  const announcementBar = document.querySelector(".Header_announcement_bar_main_new");
  const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;

  // Fixed header height
  const headerHeight = 56;
  const totalHeight = announcementBarHeight + headerHeight;

  // Update drawer positions
  const menuDrawer = document.querySelector(".menu-drawer");
  const menuBackdrop = document.querySelector(".menu-drawer__backdrop");

  if (menuDrawer) {
    menuDrawer.style.top = totalHeight + "px";
    menuDrawer.style.height = `calc(100% - ${totalHeight}px)`;
  }
  if (menuBackdrop) {
    menuBackdrop.style.top = totalHeight + "px";
  }

  // For elements with [data-scroll-direction="up"]
  const upElements = document.querySelectorAll("[data-scroll-direction='up'], [data-scroll-direction='down']");
  const totalHeightUp = headerHeight - 1;

  upElements.forEach(el => {
    const upMenu = el.querySelector(".menu-drawer");
    const upBackdrop = el.querySelector(".menu-drawer__backdrop");

    if (upMenu) {
      upMenu.style.top = totalHeightUp + "px";
      upMenu.style.height = `calc(100% - ${totalHeightUp}px)`;
    }
    if (upBackdrop) {
      upBackdrop.style.top = totalHeightUp + "px";
    }
  });
}

// Initial run
mobileMenuHeight();

// Recalculate on menu button click
const menuBtn = document.querySelector(".header__icon--menu");
if (menuBtn) {
  menuBtn.addEventListener("click", mobileMenuHeight);
}

// Recalculate on window resize
window.addEventListener("resize", mobileMenuHeight);
/* Mobile Header End */

/* Product Sticky */
// function productPageScript() {
//   const productInfo = document.querySelector(".Product_information_new product-form-component");

//   if (productInfo) {
//     window.addEventListener("scroll", function () {
//       const header = document.querySelector(".header");
//       const body = document.body;

//       const stickyHeaderTopSticky =
//         productInfo.offsetTop +
//         productInfo.offsetHeight -
//         header.offsetHeight;

//       if (window.scrollY > stickyHeaderTopSticky) {
//         if (!body.classList.contains("sticky_header_new")) {
//           body.classList.add("hide_atc_button_new");

//           setTimeout(() => {
//             body.classList.add("delay_sticky_header_new");
//           }, 100);

//           setTimeout(() => {
//             body.classList.add("sticky_header_new");
//           }, 400);
//         }
//       } else {
//         if (body.classList.contains("sticky_header_new")) {
//           body.classList.remove("sticky_header_new");

//           setTimeout(() => {
//             body.classList.remove("hide_atc_button_new");
//             body.classList.remove("delay_sticky_header_new");
//           }, 400);
//         }
//       }
//     });
//   }
// }


function productPageScript() {
  const productInfo = document.querySelector(
    ".Product_information_new .buy-buttons-block"
  );

  if (!productInfo) return;

  const body = document.body;
  let isSticky = false;

  function handleScroll() {
    const rect = productInfo.getBoundingClientRect();

    // Jab button viewport se completely upar chala jaye
    const shouldSticky = rect.bottom <= 0;

    if (shouldSticky && !isSticky) {
      isSticky = true;

      body.classList.add("hide_atc_button_new");

      setTimeout(() => {
        body.classList.add("delay_sticky_header_new");
      }, 100);

      setTimeout(() => {
        body.classList.add("sticky_header_new");
      }, 400);
    }

    if (!shouldSticky && isSticky) {
      isSticky = false;

      body.classList.remove("sticky_header_new");

      setTimeout(() => {
        body.classList.remove("hide_atc_button_new");
        body.classList.remove("delay_sticky_header_new");
      }, 400);
    }
  }

  window.addEventListener("scroll", handleScroll, {
    passive: true,
  });

  window.addEventListener("resize", handleScroll);

  handleScroll();
}

document.addEventListener("DOMContentLoaded", productPageScript);


// function productPageScript() {
//   const body = document.body;

//   window.addEventListener("scroll", function () {
//     if (window.scrollY > 200) {
//       if (!body.classList.contains("sticky_header_new")) {
//         body.classList.add("hide_atc_button_new");

//         setTimeout(() => {
//           body.classList.add("delay_sticky_header_new");
//         }, 100);

//         setTimeout(() => {
//           body.classList.add("sticky_header_new");
//         }, 400);
//       }
//     } else {
//       if (body.classList.contains("sticky_header_new")) {
//         body.classList.remove("sticky_header_new");

//         setTimeout(() => {
//           body.classList.remove("hide_atc_button_new");
//           body.classList.remove("delay_sticky_header_new");
//         }, 400);
//       }
//     }
//   });
// }

// Call the function to activate it
productPageScript();
productPageScript();
/* Product Sticky */

// Monitor body class changes (megamenu_open)
const body = document.body;
const observer = new MutationObserver(() => {
  if (body.classList.contains('megamenu_open')) {
    // Run Okendo only if available
    okeWidgetApi.initAllWidgets()
  }
});
observer.observe(body, { attributes: true, attributeFilter: ['class'] });
document.querySelector(".header__icon--menu").addEventListener("click", function () {
  okeWidgetApi.initAllWidgets();
});











